import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col, Collapse } from "react-bootstrap";
import { connect } from "react-redux";
import { replace } from "react-router-redux";
import _, { get, isEmpty } from "lodash";
import {
  AWB_NUMBER,
  BUYER_CREDIT_PCT,
  COMPANY,
  COST,
  MINIMUM_EXCHANGE_SRP,
  QUANTITY,
  SETTINGS,
  SHIPPING_TYPE
} from "APP_ROOT/constants";
import classNames from "classnames";
import moment from "moment";
import {
  formValueSelector,
  Field,
  Fields,
  change,
  getFormInitialValues
} from "redux-form";
import api from "APP_ROOT/api";
import {
  AS_IS,
  INCOMING_LINE_ITEMS,
  PURCHASE_STATUS,
  PURCHASE_STATUS_LABEL,
  PURCHASE_STATUS_OPTIONS
} from "MODULES/IncomingQuotes/constants";
import {
  ALTERNATE_ID,
  AMOUNT_INSURED,
  AS_REMOVED,
  ASSIGNED_CORE_RETURN,
  CANCELLATION_REASON,
  CANCELLATION_REASONS,
  CAP_AMOUNT,
  CAP_TYPE,
  CAP_TYPES,
  CONTAINER_FEE,
  CORE_DUE_DATE,
  CORE_REPAIR_FEE_NOT_TO_EXCEED,
  DIM_WEIGHT,
  EVALUATION_PERIOD,
  EXPECTED_SERIAL_NUMBER,
  EXTERNAL_NOTE,
  HAZMAT_FEE,
  INCIDENT,
  INSURANCE_TYPE,
  INTERNAL_NOTE,
  PERCENT_INSURED,
  PREFERRED_REPAIR_STATION_HOLD,
  PREFERRED_REPAIR_STATION_ID,
  PURCHASE_FOR_REPAIR,
  PURCHASE_FOR_REPAIR_ASSIST,
  PURCHASE_FOR_SALE,
  PURCHASE_FOR_STOCK,
  PURCHASE_ORDER,
  RESERVE_FOR_SALE_QUANTITY,
  WARRANTY_PERIOD
} from "MODULES/PurchaseOrders/constants";
import {
  BIO_HAZMAT,
  DOM,
  HAZMAT,
  TOOLING_PART_TYPE,
  TOTAL_CYCLES,
  TOTAL_HOURS
} from "MODULES/parts/constants";
import {
  CoBuyersFields,
  PurchaseForFields
} from "MODULES/PurchaseOrders/shared";
import * as actions from "MODULES/PurchaseOrders/actions";
import * as partsActions from "MODULES/parts/actions";
import {
  form,
  Form as AppForm,
  AutoCompleteField,
  AutoCompleteUserInputField,
  Check,
  FormInput,
  FormRow,
  CurrencyField,
  MonthYearField,
  NumberInput,
  Select,
  TextArea,
  CheckGroup
} from "MODULES/shared/components/Forms";
import { CONSIGNMENT, TAG_DATE_CONDITIONS } from "MODULES/Receiving/constants";
import {
  ACCOUNTING,
  CAN_EDIT_DO_NOT_EXCHANGE,
  CO_BUYER_ID,
  QUALITY_CONTROL,
  REPAIR,
  SALES,
  THIRD_BUYER_ID,
  USER
} from "MODULES/users/constants";
import { properCase } from "LIB/formatters/text";
import {
  CONDITION,
  SRP_CONDITION,
  SUGGESTED_RETAIL,
  TAGGED_BY,
  TRACE_TYPE,
  EXCHANGE_SRP,
  TRACED_TO,
  PART_ID,
  EXPIRATION,
  LEAD_TIME,
  TAG_DATE,
  FLAT_EXCHANGE_SRP,
  TAGGED_BY_ID,
  UNSELLABLE_PER_USER,
  DO_NOT_SELL_REASON,
  DO_NOT_SELL_REASON_OPTIONS,
  TOTAL_HOURS_REMAINING,
  TOTAL_CYCLES_REMAINING,
  TAGGED_BY_HOLD,
  FAA,
  EASA,
  CAAC,
  TCCA,
  UK_CAA,
  OTHER,
  OTHER_TAG_TYPE
} from "MODULES/inventories/constants";
import { toOptions } from "LIB/forms";
import { APPROVED, DO_NOT_EXCHANGE } from "MODULES/companies/constants";
import {
  EXCHANGE,
  PURCHASE_FOR_EXCHANGE,
  MOD_TO,
  MOD_TO_ID,
  CORE_DUE_DAYS,
  CORE_RETURN_DATE,
  NEW_ITEM
} from "MODULES/RepairOrders/constants";
import ToolsUsedDropDown from "MODULES/Locations/components/ToolsUsedDropDown";
import InvoiceSection from "MODULES/Orders/shared/InvoiceSection";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";
import { SRPConditionMismatchWarning } from "MODULES/PurchaseOrders/components/Detail/SRPConditionMismatchWarning";
import {
  FLAT_EXCHANGE,
  FLAT_EXCHANGE_FEE
} from "MODULES/SalesOrders/constants";
import { hasAnyOfRoles, hasPermission, hasRole } from "MODULES/users/helpers";
import { addDays } from "LIB/time";
import TierTypeExchangeSrpWarning from "MODULES/PurchaseOrders/shared/TierTypeExchangeSrpWarning";
import {
  totalCyclesRemaining,
  totalHoursRemaining
} from "MODULES/inventories/helpers";
import { shortDate } from "LIB/formatters/date";
import { CONDITIONS } from "MODULES/Shipping/constants";
import TagTypes from "MODULES/inventories/components/EditInventory/TagTypes";
import { NoteTooltip } from "MODULES/shared/components";
import AuditedNoteTooltip from "MODULES/shared/components/NoteTooltip/AuditedNoteTooltip";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";
import PartSummary from "./PartSummary";
import validate from "./validate";
import Warning from "../../../../shared/components/Warning/Warning";
import DashedSeparator from "../../../../shared/components/DashedSeparator/DashedSeparator";
import DomLifeWarning from "./DomLifeWarning";
import { PreviousSrpConditionWarning } from "../../../shared/PreviousSrpConditionWarning";
import TierTypePurchaseWarning from "../../../shared/TierTypePurchaseWarning";

const formName = "purchaseOrderLineItem";

export const SRP_CONDITION_OPTIONS = [
  { value: "overhauled", text: "Overhauled" },
  { value: "repaired", text: "Repaired" },
  { value: "inspected", text: "Inspected" },
  { value: "new_item", text: "New" },
  { value: "as_removed", text: "As Removed" },
  { value: "beyond_econ_repair", text: "Beyond Econ Repair" }
];

export const conditionOptions = part =>
  [
    { value: "overhauled", text: "Overhauled" },
    { value: "repaired", text: "Repaired" },
    { value: "inspected", text: "Inspected" },
    { value: "new_item", text: "New" },
    { value: "as_removed", text: "As Removed" },
    { value: "beyond_econ_repair", text: "Beyond Econ Repair" },
    part && part.tooling_part_type
      ? { value: "serviceable_tooling", text: "Serviceable Tooling" }
      : null
  ].filter(f => f);

function InsuranceTypeField({
  amount_insured: amountInsured,
  percent_insured: percentInsured,
  insurance_type: insuranceType,
  disabled
}) {
  const activePercent = classNames("btn btn-default", {
    active: insuranceType.input.value === "Percent"
  });
  const activeAmount = classNames("btn btn-default", {
    active: insuranceType.input.value === "Amount"
  });
  const activeNone = classNames("btn btn-default", {
    active: insuranceType.input.value === "None"
  });

  const handleInsuranceTypeChange = newVal => () => {
    if (disabled) return;
    insuranceType.input.onChange(newVal);
    if (newVal === "Amount") {
      percentInsured.input.onChange(null);
    } else if (newVal === "Percent") {
      amountInsured.input.onChange(null);
    } else {
      amountInsured.input.onChange(null);
      percentInsured.input.onChange(null);
    }
  };

  return (
    <div className="form-group" style={{ marginBottom: 20 }}>
      <label className="control-label" htmlFor="insurance_type">
        Insurance
      </label>
      <div className="btn-group btn-group-justified" role="group">
        <div
          className={activeNone}
          disabled={disabled}
          onClick={handleInsuranceTypeChange("None")}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;&nbsp;Do Not Insure
        </div>
        <div
          className={activeAmount}
          disabled={disabled}
          onClick={handleInsuranceTypeChange("Amount")}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;&nbsp;Amount
        </div>
        <div
          className={activePercent}
          disabled={disabled}
          onClick={handleInsuranceTypeChange("Percent")}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;&nbsp;Percent
        </div>
      </div>
    </div>
  );
}

InsuranceTypeField.propTypes = {
  amount_insured: PropTypes.instanceOf(Object),
  percent_insured: PropTypes.instanceOf(Object),
  insurance_type: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool
};

function AmountInsuredFields({ amount, disabled }) {
  return (
    <div className="col-md-4">
      <CurrencyField
        name={amount.input.name}
        label="Insurance Amount"
        disabled={disabled}
        required
      />
    </div>
  );
}

AmountInsuredFields.propTypes = {
  amount: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool
};

export function exchangeSrpValidated(selectedLineItem) {
  // Validate Exchange SRP if the line item is new (undefined) or if it was
  // created after 2019-06-14
  return (
    selectedLineItem === undefined ||
    moment(selectedLineItem.createdAt).isAfter(moment("2019-06-14 07:00:00"))
  );
}

export function exchangeSrpNotAllowed(part) {
  return part && part.pass_fail;
}

export function ExchangeSrpWarning() {
  return (
    <Warning>
      This part is flagged as a pass/fail item. An Exchange is not allowed.
    </Warning>
  );
}

export function DOMIsRequiredWarning() {
  return <Warning>Part is DOM Sensitive. DOM Required.</Warning>;
}

export function UnauthorizedRepairStationSelectedWarning() {
  return (
    <Warning>
      Note: This Repair Station is not approved. Unless you are reserving this
      unit for repair to a different repair station, PO will require management
      approval before you are able to send PO.
    </Warning>
  );
}

export function PurchaseForSaleQuantityWarning() {
  return (
    <Warning>
      Please ensure all items on PO are purchased for sale. If not, separate
      them into different line items.
    </Warning>
  );
}

export function SixMonthsOldTagDateWarning() {
  return (
    <Warning>
      This purchase is for TAG DATE older than 6 months. Manager Approval will
      be required.
    </Warning>
  );
}

export function UnauthorizedPreferredRepairStationSelectedWarning() {
  return (
    <Warning>
      Note: This Repair Station is not approved. PO will require management
      approval before you are able to send PO.
    </Warning>
  );
}

function PercentInsuredFields({ percent, cost, quantity, disabled }) {
  const costValue = cost.input.value || 0;
  const quantityValue = quantity.input.value || 0;
  const percentValue = percent.input.value || 0;
  const subtotal = parseFloat(costValue) * parseFloat(quantityValue);
  const insuranceAmount = Math.ceil(subtotal * percentValue) / 100;

  return (
    <Col md={12}>
      <FormRow>
        <Col md={4}>
          <Field
            name={percent.input.name}
            label="Insurance Percent"
            component={NumberInput}
            parse={value => value && parseInt(value, 10)}
            addon={<i className="fa fa-percent" />}
            disabled={disabled}
            required
          />
        </Col>
        <Col md={4}>
          <div className="form-group">
            <label className="control-label" htmlFor="insurance_type">
              Insurance Amount
            </label>
            <div className="input-group">
              <span className="input-group-addon">
                <i className="fa fa-dollar" />
              </span>
              <input
                className="form-control"
                type="text"
                value={insuranceAmount}
                disabled
                readOnly
              />
            </div>
          </div>
        </Col>
      </FormRow>
    </Col>
  );
}

PercentInsuredFields.propTypes = {
  percent: PropTypes.instanceOf(Object),
  cost: PropTypes.instanceOf(Object),
  quantity: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool
};

function InsuranceFields({
  amount_insured: amountInsured,
  percent_insured: percentInsured,
  insurance_type: insuranceType,
  cost,
  quantity,
  disabled
}) {
  if (insuranceType.input.value === "Amount") {
    return <AmountInsuredFields amount={amountInsured} disabled={disabled} />;
  } else if (insuranceType.input.value === "Percent") {
    return (
      <PercentInsuredFields
        insuranceType={insuranceType}
        percent={percentInsured}
        cost={cost}
        quantity={quantity}
        disabled={disabled}
      />
    );
  }

  return null;
}

InsuranceFields.propTypes = {
  amount_insured: PropTypes.instanceOf(Object),
  percent_insured: PropTypes.instanceOf(Object),
  insurance_type: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool,
  cost: PropTypes.instanceOf(Object),
  quantity: PropTypes.instanceOf(Object)
};

export function LineHazmatFields({ hazmat, bio_hazmat, disabled }) {
  return (
    <div className="btn-group btn-group-justified" data-toggle="buttons">
      <Check
        input={hazmat.input}
        label={properCase(HAZMAT)}
        icon="fa-warning"
        disabled={disabled}
      />
      <Check
        input={bio_hazmat.input}
        label={properCase(BIO_HAZMAT)}
        icon="fa-flask"
        disabled={disabled}
      />
    </div>
  );
}

LineHazmatFields.propTypes = {
  hazmat: PropTypes.instanceOf(Object).isRequired,
  bio_hazmat: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool
};

export function AsIsField({
  as_is: asIs,
  condition,
  evaluation_period: evaluationPeriod,
  purchase_for_stock: purchaseForStock,
  disabled
}) {
  const handleChange = val => {
    asIs.input.onChange(val);
    if (val === true) {
      evaluationPeriod.input.onChange(0);
    } else {
      evaluationPeriod.input.onChange(30);

      if (condition.input.value === AS_REMOVED) {
        purchaseForStock.input.onChange(false);
      }
    }
  };

  const input = { ...asIs.input, onChange: handleChange };
  return (
    <div className="btn-group btn-group-justified" data-toggle="buttons">
      <Check
        input={input}
        label={properCase(AS_IS)}
        icon="fa-check-circle"
        disabled={disabled}
      />
    </div>
  );
}

AsIsField.propTypes = {
  as_is: PropTypes.instanceOf(Object).isRequired,
  condition: PropTypes.instanceOf(Object).isRequired,
  evaluation_period: PropTypes.instanceOf(Object).isRequired,
  purchase_for_stock: PropTypes.instanceOf(Object).isRequired,
  disabled: PropTypes.bool
};

export function tagDateIsOlder(tagDate) {
  return moment().diff(tagDate, "months") > 6;
}

export class Form extends Component {
  static propTypes = {
    getFieldValue: PropTypes.func.isRequired,
    setTaggedById: PropTypes.func.isRequired,
    setTaggedByHold: PropTypes.func.isRequired,
    showBuyers: PropTypes.bool,
    buyerCreditPct: PropTypes.string,
    cap_type: PropTypes.string,
    condition: PropTypes.string,
    cost: PropTypes.string,
    currentUser: PropTypes.instanceOf(Object),
    id: PropTypes.number,
    lineItem: PropTypes.shape({
      co_buyer: PropTypes.shape({}),
      third_buyer: PropTypes.shape({}),
      part: PropTypes.shape({}),
      part_id: PropTypes.string
    }),
    quantity: PropTypes.number,
    renderFooter: PropTypes.func,
    resetAlternatePartField: PropTypes.func.isRequired,
    resetExchangeSrpField: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    searchAlternates: PropTypes.func.isRequired,
    selectedLineItem: PropTypes.instanceOf(Object),
    searchBuyers: PropTypes.func.isRequired,
    searchParts: PropTypes.func.isRequired,
    searchRepairStations: PropTypes.func.isRequired,
    setExpectedDate: PropTypes.func.isRequired,
    setLeadTime: PropTypes.func.isRequired,
    setHeavyPackage: PropTypes.func.isRequired,
    setHazardFields: PropTypes.func.isRequired,
    setPartId: PropTypes.func.isRequired,
    shippingType: PropTypes.string,
    domLifeYears: PropTypes.number,
    llp: PropTypes.bool,
    selectedPart: PropTypes.instanceOf(Object).isRequired,
    setSelectedPart: PropTypes.func.isRequired,
    setPreferredRepairStationHold: PropTypes.func.isRequired,
    resetPreferredRepairStation: PropTypes.func.isRequired
  };

  static defaultProps = {
    modalMode: true,
    showBuyers: true
  };

  state = {
    alternateOptions: []
  };

  componentWillMount() {
    if (this.props.lineItem) {
      const id = this.props.lineItem.part_id;
      const part = this.props.lineItem.part;
      const coBuyer = this.props.lineItem.co_buyer;
      const thirdBuyer = this.props.lineItem.third_buyer;

      if (part) {
        this.props.setHazardFields(part);
        this.props.setHeavyPackage(part);
        this.fetchAlternates(part.id);
      }

      this.props.setPartId(id);
      this.props.setSelectedPart(part);
      this.setState({
        selectedCoBuyer: coBuyer,
        selectedThirdBuyer: thirdBuyer
      });
    }

    this.setState({
      selectedReserveForSeller:
        get(this.props.lineItem, "reserve_for_seller") || this.props.currentUser
    });

    if (this.props.selectedLineItem) {
      const {
        part,
        mod_to: modTo,
        co_buyer,
        third_buyer,
        preferred_repair_station: preferredRepairStation,
        reserve_for_seller: reserveForSeller
      } = this.props.selectedLineItem;

      this.setState({
        selectedModTo: modTo,
        selectedPart: part,
        selectedCoBuyer: co_buyer,
        selectedThirdBuyer: third_buyer,
        selectedPreferredRepairStation: preferredRepairStation,
        selectedReserveForSeller: reserveForSeller || this.props.currentUser
      });
      if (exchangeSrpNotAllowed(part)) {
        this.props.resetExchangeSrpField();
      }
      this.props.setSelectedPart(part);
      this.fetchAlternates(part.id);
    }
    const defaultLeadTime = this.props.initialValues.lead_time || 0;

    const initialExpectedDate = this.calculateExpectedDate(
      defaultLeadTime,
      this.props.selectedLineItem
        ? new Date(this.props.selectedLineItem.created_at)
        : new Date()
    );
    this.props.setExpectedDate(initialExpectedDate);
  }

  get repairStationRequired() {
    const { purchaseForRepair, condition, getField } = this.props;

    return (
      purchaseForRepair ||
      (condition === AS_REMOVED &&
        !getField(PURCHASE_FOR_SALE) &&
        !getField(PURCHASE_FOR_STOCK))
    );
  }

  fetchAlternates = partId => {
    if (!partId) return;
    this.props.searchAlternates(partId).then(results =>
      this.setState({
        alternateOptions: results.map(item => ({
          text: item.name,
          value: item.id
        }))
      })
    );
  };

  calculateExpectedDate = (leadTimeDays, date) => {
    date.setDate(date.getDate() + leadTimeDays);
    return date.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
  };

  calculateDifferenceInDays = (startDate, endDate) => {
    const diffInTime = endDate.getTime() - startDate.getTime();
    return Math.round(diffInTime / (1000 * 3600 * 24));
  };

  handleDateChange = val => {
    const selectedDate = new Date(val);
    const today = this.props.selectedLineItem
      ? new Date(this.props.selectedLineItem.created_at)
      : new Date();
    today.setHours(0, 0, 0, 0);

    const leadTime = this.calculateDifferenceInDays(today, selectedDate);

    this.props.setLeadTime(leadTime);
  };

  handlePartSelected = part => {
    this.props.setSelectedPart(part);
    this.props.resetAlternatePartField();
    if (part) {
      if (exchangeSrpNotAllowed(part)) {
        this.props.resetExchangeSrpField();
      }
      this.props.setHazardFields(part);
      this.props.setHeavyPackage(part);
      this.fetchAlternates(part.id);

      this.props.change(
        TOTAL_HOURS_REMAINING,
        totalHoursRemaining(part, Number(this.props.getFieldValue(TOTAL_HOURS)))
      );

      this.props.change(
        TOTAL_CYCLES_REMAINING,
        totalCyclesRemaining(
          part,
          Number(this.props.getFieldValue(TOTAL_CYCLES))
        )
      );

      if (part.dom_sensitive) {
        this.props.change(QUANTITY, 1);
      }
    }
  };

  inventoryLocked(field) {
    const { currentUser, selectedLineItem, selectedPart } = this.props;

    if (!selectedLineItem) return false;

    const {
      buyer: { id: buyerId },
      co_buyer_id: coBuyerId,
      third_buyer_id: thirdBuyerId
    } = selectedLineItem;

    const userCanEdit =
      hasAnyOfRoles(currentUser, [QUALITY_CONTROL, ACCOUNTING]) ||
      [buyerId, coBuyerId, thirdBuyerId].includes(currentUser.id);

    const received =
      selectedLineItem.received || selectedLineItem.quantity_received > 0;

    const defaultPermission =
      received || !userCanEdit || selectedLineItem.cancelled;
    if (!field || selectedLineItem.cancelled) {
      return defaultPermission;
    }

    return {
      [EXCHANGE_SRP]:
        !(userCanEdit || hasRole(currentUser, SALES)) ||
        selectedLineItem.received ||
        exchangeSrpNotAllowed(selectedPart),
      [QUANTITY]: selectedLineItem.cancelled || !userCanEdit,
      [SUGGESTED_RETAIL]:
        !(userCanEdit || hasRole(currentUser, SALES)) ||
        selectedLineItem.received,
      [COST]:
        selectedLineItem.consignment_type !== CONSIGNMENT && defaultPermission
    }[field];
  }

  searchCompanies = filter =>
    api.companies
      .search({
        filter,
        page: 1,
        limit: 20
      })
      .then(resp => resp.data.results);

  handleTaggedBy = company => {
    const { setTaggedById, setTaggedByHold } = this.props;

    if (company && company.id) {
      setTaggedById(company.id);
      setTaggedByHold(company.repair_station_status !== APPROVED);
    } else {
      setTaggedByHold(false);
    }
  };

  handlePreferredRepairStation = company => {
    const { setPreferredRepairStationHold } = this.props;

    if (company && company.id) {
      setPreferredRepairStationHold(company.repair_station_status !== APPROVED);
    }
  };

  resetPreferredRepairStation = () => {
    const { resetPreferredRepairStation } = this.props;

    resetPreferredRepairStation();

    this.setState({ selectedPreferredRepairStation: null });
  };

  toggleBuyer = buyer => this.setState(buyer);

  render() {
    const {
      getFieldValue,
      buyerCreditPct,
      currentUser,
      capType,
      condition,
      containerFee,
      cost,
      displaySrpInventoryTable,
      showExpectedDateField,
      getInitialFieldValue,
      paid,
      quantity,
      searchBuyers,
      searchParts,
      searchRepairStations,
      selectedLineItem,
      setFieldValue,
      shippingType,
      hazmatFee,
      markedHazardous,
      purchaseForStock,
      srpCondition,
      srp,
      getField,
      modalMode,
      renderFooter,
      selectedPart,
      domLifeYears,
      llp,
      modTo,
      dom
    } = this.props;

    const buyerCreditPctOptions = [
      { text: "75%", value: "75.0" },
      { text: "50%", value: "50.0" },
      { text: "25%", value: "25.0" }
    ];
    const cancelled = selectedLineItem && selectedLineItem.cancelled;
    const assignedCoreReturn = _.get(
      this.props.selectedLineItem,
      ASSIGNED_CORE_RETURN
    );

    const received =
      selectedLineItem &&
      Number(getFieldValue(QUANTITY)) <=
        Number(selectedLineItem.quantity_received);

    const {
      selectedModTo,
      selectedCoBuyer,
      selectedThirdBuyer,
      selectedPreferredRepairStation,
      selectedReserveForSeller,
      alternateOptions
    } = this.state;

    const locked = this.inventoryLocked();
    const leadTimeLocked = hasRole(currentUser, QUALITY_CONTROL)
      ? false
      : locked;
    const formProps = {
      ...this.props,
      editable:
        !(
          locked &&
          this.inventoryLocked(QUANTITY) &&
          this.inventoryLocked(SUGGESTED_RETAIL)
        ) || cancelled
    };

    const taggedByHold = getFieldValue(TAGGED_BY_HOLD);
    const preferredRepairStationHold = getFieldValue(
      PREFERRED_REPAIR_STATION_HOLD
    );

    const showTagDateWarning =
      purchaseForStock && tagDateIsOlder(getFieldValue(TAG_DATE));

    const skipFieldsRequiredForPurchaseFor =
      getFieldValue(PURCHASE_FOR_REPAIR_ASSIST) ||
      (getFieldValue(PURCHASE_FOR_SALE) &&
        Number(getFieldValue(QUANTITY)) ===
          Number(getFieldValue(RESERVE_FOR_SALE_QUANTITY)));

    const clearPurchaseFor = (val, fields) => {
      if (!val) return null;
      return fields.forEach(f => this.props.setFieldValue(f)(false));
    };
    const minOutrightValueForExchangeSettings = useSettings()
      .min_outright_value_for_exchange_consideration;
    const minOutrightValueForExchangeConsideration = parseFloat(
      minOutrightValueForExchangeSettings
    );
    const suggestedRetail = getFieldValue(SUGGESTED_RETAIL) || 0;
    const shouldCheckMinValue =
      minOutrightValueForExchangeSettings !== null &&
      minOutrightValueForExchangeSettings !== undefined;

    return (
      <AppForm {...formProps} modal={modalMode}>
        <AppForm.Body>
          {purchaseForStock &&
            !isEmpty(srpCondition) &&
            !isEmpty(condition) &&
            srpCondition !== condition && <SRPConditionMismatchWarning />}
          {exchangeSrpNotAllowed(selectedPart) && <ExchangeSrpWarning />}
          <TierTypePurchaseWarning
            part={selectedPart}
            cost={getField(COST)}
            quantity={getField(QUANTITY)}
            initialQuantity={getInitialFieldValue(QUANTITY)}
          />
          <div className="row">
            <Col md={modalMode ? 8 : 12}>
              <div
                className="row row-col-gutters-half"
                style={{ marginTop: "26px" }}
              >
                <Col md={4}>
                  <Field
                    name={PART_ID}
                    label="Part #"
                    placeholder="Type a part's number..."
                    component={AutoCompleteField}
                    search={searchParts}
                    selectedItem={selectedPart}
                    formatItem={result => result && result.part_number}
                    onItemSelected={i => i && this.handlePartSelected(i)}
                    disabled={locked}
                    required
                  />
                </Col>
                <Col md={4}>
                  <Field
                    name={ALTERNATE_ID}
                    label="Buy As Alternate"
                    placeholder="Type a part's number..."
                    component={Select}
                    options={alternateOptions}
                    addon={<i className="fa fa-exchange" />}
                    disabled={alternateOptions.length === 0}
                  />
                </Col>
              </div>
              <DashedSeparator />
              <FormRow>
                <Col md={3}>
                  <CheckGroup title={properCase(EXCHANGE)}>
                    <Field
                      name={PURCHASE_FOR_EXCHANGE}
                      label={properCase(EXCHANGE)}
                      icon="fa-check-circle"
                      component={Check}
                      disabled={
                        (selectedPart && selectedPart.pass_fail) || locked
                      }
                      onChange={(_evt, val) => {
                        if (val) {
                          [
                            PURCHASE_FOR_REPAIR,
                            PURCHASE_FOR_STOCK,
                            PURCHASE_FOR_REPAIR_ASSIST
                          ].forEach(f => setFieldValue(f)(false));
                          if (Number(getFieldValue(QUANTITY)) === 1) {
                            setFieldValue(RESERVE_FOR_SALE_QUANTITY)(1);
                          }

                          setFieldValue(CORE_DUE_DAYS)(30);
                          const days = addDays(new Date(), 30);
                          setFieldValue(CORE_RETURN_DATE)(
                            new Date(days).toISOString().split("T")[0]
                          );
                        }
                      }}
                    />
                  </CheckGroup>
                </Col>
                {getFieldValue(PURCHASE_FOR_EXCHANGE) && (
                  <Col md={3}>
                    <CheckGroup title={properCase(FLAT_EXCHANGE)}>
                      <Field
                        name={FLAT_EXCHANGE}
                        label={properCase(FLAT_EXCHANGE)}
                        icon="fa-check-circle"
                        component={Check}
                      />
                    </CheckGroup>
                  </Col>
                )}
              </FormRow>
              <DashedSeparator />
              <FormRow>
                <Col md={3}>
                  <Field
                    name={CONDITION}
                    component={Select}
                    options={conditionOptions(selectedPart)}
                    label={properCase(CONDITION)}
                    disabled={locked}
                    required
                  />
                </Col>
                <Col md={2}>
                  <Field
                    name={QUANTITY}
                    component={FormInput}
                    label={[
                      "QTY",
                      selectedPart &&
                        selectedPart.dom_sensitive && (
                          <NoteTooltip
                            color="rgba(255, 255, 255, 0.25)"
                            icon="fa-info-circle"
                            placement="top"
                            note="PN's labeled DOM sensitive must be purchased one per line item."
                          />
                        )
                    ]}
                    type="number"
                    disabled={
                      this.inventoryLocked(QUANTITY) ||
                      (selectedPart && selectedPart.dom_sensitive)
                    }
                    required
                    onBlur={(_ev, qty) => {
                      if (Number(qty) !== 1) {
                        setFieldValue(EXPECTED_SERIAL_NUMBER)(null);
                      }
                      if (
                        Number(qty) === 1 &&
                        getFieldValue(PURCHASE_FOR_SALE)
                      ) {
                        setFieldValue(RESERVE_FOR_SALE_QUANTITY)(1);
                      }
                    }}
                    inputProps={{
                      min: 0
                    }}
                  />
                </Col>
                <Col md={3}>
                  <CurrencyField
                    name={COST}
                    label={
                      getFieldValue(PURCHASE_FOR_EXCHANGE)
                        ? "Outright Price"
                        : "Cost/Unit"
                    }
                    disabled={
                      (this.inventoryLocked(COST) &&
                        this.props.currentUser.role !== "admin") ||
                      paid
                    }
                    required
                  />
                </Col>
                {getFieldValue(PURCHASE_FOR_EXCHANGE) && (
                  <Col md={3}>
                    <CurrencyField
                      name={EXCHANGE_FEE}
                      label={
                        getFieldValue(FLAT_EXCHANGE)
                          ? properCase(FLAT_EXCHANGE_FEE)
                          : properCase(EXCHANGE_FEE)
                      }
                      disabled={
                        (selectedPart && selectedPart.pass_fail) || locked
                      }
                      required
                    />
                  </Col>
                )}
              </FormRow>
              <FormRow>
                <Col md={3}>
                  <Field
                    name={EXPIRATION}
                    label="Expiration Date"
                    component={FormInput}
                    type="date"
                    disabled={locked}
                  />
                </Col>
                <Col md={3}>
                  <Field
                    name={"warranty_period"}
                    component={Select}
                    options={toOptions(WARRANTY_PERIOD)}
                    label="Warranty Period"
                    disabled={locked && received}
                  />
                </Col>
                {getFieldValue(PURCHASE_FOR_EXCHANGE) && [
                  <Col md={3}>
                    <Field
                      name={CORE_DUE_DAYS}
                      component={FormInput}
                      label={properCase(CORE_DUE_DAYS)}
                      onChange={(_evt, val) => {
                        if (val) {
                          const days = addDays(new Date(), Number(val));
                          setFieldValue(CORE_RETURN_DATE)(
                            new Date(days).toISOString().split("T")[0]
                          );
                        }
                      }}
                      required
                    />
                  </Col>,
                  <Col md={3}>
                    <Field
                      label={properCase(CORE_DUE_DATE)}
                      name={CORE_RETURN_DATE}
                      component={FormInput}
                      type="date"
                      required
                    />
                  </Col>,
                  <Col md={3}>
                    <CurrencyField
                      label="Avg Repair (NTX)"
                      name={CORE_REPAIR_FEE_NOT_TO_EXCEED}
                      required={getFieldValue(FLAT_EXCHANGE)}
                    />
                  </Col>
                ]}
              </FormRow>
              <DashedSeparator />
              <FormRow>
                <Col md={5}>
                  <div className="form-group">
                    <label htmlFor="warnings" className="control-label">
                      Line Hazmat
                    </label>
                    <br />
                    <Fields
                      names={[HAZMAT, BIO_HAZMAT]}
                      component={LineHazmatFields}
                      disabled={locked}
                    />
                  </div>
                </Col>
                <Col md={2}>
                  <div className="form-group">
                    <label htmlFor={AS_IS} className="control-label">
                      As Is
                    </label>
                    <br />
                    <Fields
                      names={[
                        AS_IS,
                        CONDITION,
                        EVALUATION_PERIOD,
                        PURCHASE_FOR_STOCK
                      ]}
                      component={AsIsField}
                      disabled={locked}
                    />
                  </div>
                </Col>
                <Col md={3}>
                  <CheckGroup title="Heavy Package / DIM WT" justified>
                    <Field
                      name={DIM_WEIGHT}
                      component={Check}
                      label="Hvy Pkg / DIM"
                      icon="fa-check-circle"
                      disabled={locked}
                    />
                  </CheckGroup>
                </Col>
                <Col md={2}>
                  <CheckGroup title={properCase(INCIDENT)} justified>
                    <Field
                      name={INCIDENT}
                      label={properCase(INCIDENT)}
                      component={Check}
                      icon="fa-check-circle"
                      disabled={locked}
                    />
                  </CheckGroup>
                </Col>
              </FormRow>
              {selectedModTo && (
                <Warning>
                  SRP Info will be applied to PN {selectedModTo.part_number}
                </Warning>
              )}
              <FormRow>
                <Col md={3}>
                  <CheckGroup title="Do Not Exchange" justified>
                    <Field
                      name={DO_NOT_EXCHANGE}
                      label={properCase(DO_NOT_EXCHANGE)}
                      disabled={
                        !hasPermission(currentUser, CAN_EDIT_DO_NOT_EXCHANGE)
                      }
                      onChange={(_ev, val) => {
                        if (val) setFieldValue(EXCHANGE_SRP)("");
                      }}
                      component={Check}
                    />
                  </CheckGroup>
                </Col>
                <Col md={3}>
                  <CheckGroup title="Do Not Sell!" justified>
                    <Field
                      name={UNSELLABLE_PER_USER}
                      component={props => (
                        <Check {...props} icon="fa-diamond" />
                      )}
                      label="Do Not Sell!"
                    />
                  </CheckGroup>
                </Col>
                {getFieldValue(UNSELLABLE_PER_USER) && (
                  <Col md={6}>
                    <Field
                      name={DO_NOT_SELL_REASON}
                      label="Reason for Do Not Sell?"
                      component={Select}
                      options={DO_NOT_SELL_REASON_OPTIONS}
                      required
                    />
                  </Col>
                )}
              </FormRow>
              <DomLifeWarning
                part={selectedPart}
                domFromLineItem={getField(DOM)}
              />
              <PreviousSrpConditionWarning
                displayInventory={displaySrpInventoryTable}
                srpCondition={srpCondition}
                srp={srp}
                partId={selectedPart.id}
              />
              {showTagDateWarning && <SixMonthsOldTagDateWarning />}
              {taggedByHold && <UnauthorizedRepairStationSelectedWarning />}
              {Number(quantity) > 1 &&
                getFieldValue(PURCHASE_FOR_SALE) && (
                  <PurchaseForSaleQuantityWarning />
                )}
              {selectedPart.dom_sensitive &&
                _.isEmpty(dom) && <DOMIsRequiredWarning />}
              <hr className="hr-xs hr-dashed" />
              <PurchaseForFields
                clearPurchaseFor={clearPurchaseFor}
                formName={formName}
                getFieldValue={getFieldValue}
                selectedReserveForSeller={selectedReserveForSeller}
                searchBuyers={searchBuyers}
                setFieldValue={setFieldValue}
                shippingType={shippingType}
                disabled={locked}
                qtyDisabled={this.inventoryLocked(QUANTITY)}
                condition={condition}
                onPurchaseForStockChange={this.resetPreferredRepairStation}
                onPurchaseForSaleChange={val => {
                  if (val && Number(getFieldValue(QUANTITY)) === 1) {
                    setFieldValue(RESERVE_FOR_SALE_QUANTITY)(1);
                  }
                  if (!val) setFieldValue(RESERVE_FOR_SALE_QUANTITY)("");
                }}
                onPurchaseForRepair={v => {
                  if (
                    v &&
                    get(this.props.purchaseOrder, SHIPPING_TYPE) === COMPANY
                  ) {
                    this.setState({
                      selectedPreferredRepairStation: get(
                        this.props.purchaseOrder,
                        "ship_to_company"
                      )
                    });
                    setFieldValue(PREFERRED_REPAIR_STATION_ID)(
                      get(this.props.purchaseOrder, "ship_to_company_id")
                    );
                  }
                }}
              />
              <TierTypeExchangeSrpWarning
                part={selectedPart}
                exchangeSrp={getFieldValue(EXCHANGE_SRP)}
                srp={getFieldValue(SUGGESTED_RETAIL)}
              />
              <FormRow>
                <Col md={4}>
                  <Field
                    name={SRP_CONDITION}
                    component={Select}
                    options={conditionOptions(selectedPart)}
                    label="SRP Condition"
                    disabled={locked}
                    required={!skipFieldsRequiredForPurchaseFor}
                  />
                </Col>
                <Col md={4}>
                  <CurrencyField
                    name={SUGGESTED_RETAIL}
                    label="SRP"
                    disabled={this.inventoryLocked(SUGGESTED_RETAIL)}
                    required={!skipFieldsRequiredForPurchaseFor}
                  />
                </Col>
                <Col md={4}>
                  <CurrencyField
                    name={EXCHANGE_SRP}
                    label={
                      getFieldValue(FLAT_EXCHANGE)
                        ? properCase(FLAT_EXCHANGE_SRP)
                        : properCase(EXCHANGE_SRP)
                    }
                    disabled={
                      this.inventoryLocked(EXCHANGE_SRP) ||
                      exchangeSrpNotAllowed(selectedPart) ||
                      getFieldValue(DO_NOT_EXCHANGE)
                    }
                    required={
                      (!shouldCheckMinValue ||
                        suggestedRetail >=
                          minOutrightValueForExchangeConsideration) &&
                      exchangeSrpValidated(selectedLineItem) &&
                      !exchangeSrpNotAllowed(selectedPart) &&
                      ![NEW_ITEM, AS_REMOVED].includes(
                        getFieldValue(CONDITION)
                      ) &&
                      !getFieldValue(DO_NOT_EXCHANGE) &&
                      !skipFieldsRequiredForPurchaseFor &&
                      !get(selectedPart, TOOLING_PART_TYPE)
                    }
                  />
                </Col>
              </FormRow>
              <FormRow>
                <Col md={4}>
                  <MonthYearField
                    name={TAG_DATE}
                    label={properCase(TAG_DATE)}
                    component={FormInput}
                    required={TAG_DATE_CONDITIONS.includes(condition)}
                    disabled={locked}
                  />
                </Col>
                <Col md={4}>
                  <Field
                    name={TAGGED_BY}
                    label={properCase(TAGGED_BY)}
                    placeholder="Search by a company's name"
                    component={AutoCompleteUserInputField}
                    required={TAG_DATE_CONDITIONS.includes(condition)}
                    search={this.searchCompanies}
                    selectedItem={
                      selectedLineItem && selectedLineItem.tagged_by
                    }
                    handleTaggedBy={result => this.handleTaggedBy(result)}
                    formatItem={result =>
                      (typeof result === "object" ? result.name : result) || ""}
                    disabled={locked}
                  />
                </Col>
                <Col md={4}>
                  <ToolsUsedDropDown
                    disabled={locked}
                    selectedLineItem={selectedLineItem}
                    notRequired={getFieldValue(PURCHASE_FOR_REPAIR_ASSIST)}
                  />
                </Col>
              </FormRow>
              <FormRow>
                <Col md={4}>
                  <MonthYearField
                    name="dom"
                    label="DOM"
                    component={FormInput}
                    required={
                      (domLifeYears && llp) || selectedPart.dom_sensitive
                    }
                    disabled={locked}
                  />
                </Col>
                <Col md={4}>
                  <Field
                    name={TRACE_TYPE}
                    component={Select}
                    options={toOptions(INCOMING_LINE_ITEMS.traceTypes)}
                    label="Expected Trace Type"
                    disabled={locked && received}
                    required
                  />
                </Col>
                <Col md={4}>
                  <Field
                    name={TRACED_TO}
                    component={FormInput}
                    label="Expected Trace To"
                    disabled={locked}
                  />
                </Col>
              </FormRow>
              <FormRow>
                <Col md={4}>
                  {!showExpectedDateField && (
                    <Field
                      name={LEAD_TIME}
                      label="Lead Time (Days)"
                      component={FormInput}
                      disabled={leadTimeLocked}
                      required
                    />
                  )}
                  {showExpectedDateField && (
                    <Field
                      name="expected_date"
                      label={
                        <React.Fragment>
                          Expected Date
                          <AuditedNoteTooltip
                            obj={selectedLineItem}
                            field="lead_time"
                            includeTime
                          />
                        </React.Fragment>
                      }
                      component={FormInput}
                      onChange={(e, val) => this.handleDateChange(val)}
                      type="date"
                    />
                  )}
                </Col>
                <Col md={4}>
                  <Field
                    name={PURCHASE_STATUS}
                    component={Select}
                    options={PURCHASE_STATUS_OPTIONS}
                    label={PURCHASE_STATUS_LABEL}
                    required={!getFieldValue(CONSIGNMENT)}
                  />
                </Col>
                <Col md={4}>
                  <Field
                    name={EXPECTED_SERIAL_NUMBER}
                    label="Expected Serial #"
                    component={FormInput}
                    disabled={received || Number(quantity) !== 1}
                  />
                </Col>
              </FormRow>
              <FormRow>
                <Col md={3}>
                  <CheckGroup justified title={properCase(MOD_TO)}>
                    <Field
                      name={MOD_TO}
                      label={properCase(MOD_TO)}
                      icon="fa-check-circle"
                      component={Check}
                      disabled={locked || !getFieldValue(PURCHASE_FOR_REPAIR)}
                    />
                  </CheckGroup>
                </Col>

                <Collapse in={modTo || false} unmountOnExit>
                  <Col md={4}>
                    <Field
                      name={MOD_TO_ID}
                      label={properCase(MOD_TO)}
                      placeholder="Type a part's number..."
                      selectedItem={selectedModTo}
                      component={AutoCompleteField}
                      onItemSelected={item =>
                        item && this.setState({ selectedModTo: item })}
                      search={searchParts}
                      formatItem={result => result && result.part_number}
                      disabled={locked}
                    />
                  </Col>
                </Collapse>
              </FormRow>
              {selectedPart &&
                selectedPart.llp && (
                  <FormRow>
                    <Col md={3}>
                      <Field
                        name={TOTAL_HOURS}
                        label={properCase(TOTAL_HOURS)}
                        component={NumberInput}
                        roundDigits={0}
                        onChange={(_e, val) =>
                          this.props.change(
                            TOTAL_HOURS_REMAINING,
                            totalHoursRemaining(selectedPart, val)
                          )}
                      />
                    </Col>
                    <Col md={3}>
                      <Field
                        name={TOTAL_CYCLES}
                        label={properCase(TOTAL_CYCLES)}
                        component={NumberInput}
                        roundDigits={0}
                        onChange={(_e, val) =>
                          this.props.change(
                            TOTAL_CYCLES_REMAINING,
                            totalCyclesRemaining(selectedPart, val)
                          )}
                      />
                    </Col>
                    <Col md={3}>
                      <Field
                        name={TOTAL_HOURS_REMAINING}
                        label={properCase(TOTAL_HOURS_REMAINING)}
                        disabled
                        component={NumberInput}
                        roundDigits={0}
                      />
                    </Col>
                    <Col md={3}>
                      <Field
                        name={TOTAL_CYCLES_REMAINING}
                        disabled
                        label={properCase(TOTAL_CYCLES_REMAINING)}
                        component={NumberInput}
                        roundDigits={0}
                      />
                    </Col>
                  </FormRow>
                )}
              <FormRow>
                <Col md={12}>
                  <Fields
                    component={TagTypes}
                    names={[
                      FAA,
                      EASA,
                      CAAC,
                      TCCA,
                      UK_CAA,
                      OTHER,
                      OTHER_TAG_TYPE
                    ]}
                    formName={formName}
                    disabled={locked}
                  />
                </Col>
              </FormRow>
              {this.props.showBuyers && (
                <React.Fragment>
                  <DashedSeparator />
                  <h4>Buyers</h4>
                  <FormRow>
                    <Col md={5}>
                      <Field
                        name="read_only_buyer"
                        label="Buyer"
                        component={FormInput}
                        disabled
                        required
                      />
                    </Col>
                    <Col md={3}>
                      <Field
                        name={BUYER_CREDIT_PCT}
                        className="text-right"
                        component={Select}
                        options={buyerCreditPctOptions}
                        prompt={false}
                        label="Buyer Credit"
                        disabled={locked}
                        required
                      />
                    </Col>
                  </FormRow>
                  <FormRow>
                    <CoBuyersFields
                      toggleBuyer={this.toggleBuyer}
                      buyerCreditPct={buyerCreditPct}
                      selectedCoBuyer={selectedCoBuyer}
                      selectedThirdBuyer={selectedThirdBuyer}
                      numberOfBuyers={
                        [
                          getFieldValue(CO_BUYER_ID),
                          getFieldValue(THIRD_BUYER_ID)
                        ].filter(s => s).length + 1
                      }
                      searchBuyers={searchBuyers}
                      disabled={locked}
                    />
                  </FormRow>
                </React.Fragment>
              )}
              <InvoiceSection
                hidden={
                  !hasAnyOfRoles(currentUser, [
                    ACCOUNTING,
                    QUALITY_CONTROL,
                    REPAIR,
                    SALES
                  ])
                }
                disabled={hasAnyOfRoles(currentUser, [SALES, REPAIR])}
                orderType={PURCHASE_ORDER}
              />
              <DashedSeparator />
              {preferredRepairStationHold && (
                <UnauthorizedPreferredRepairStationSelectedWarning />
              )}
              <h4>Shipping & Repairs</h4>
              <FormRow>
                {selectedLineItem && (
                  <Col md={6}>
                    <Field
                      name={AWB_NUMBER}
                      component={FormInput}
                      label="AWB #"
                      disabled={received}
                    />
                  </Col>
                )}
                <Col md={3}>
                  <CurrencyField
                    name={CONTAINER_FEE}
                    label="Container/Crate Fee"
                    disabled={locked}
                  />
                </Col>
                <Col md={3}>
                  <CurrencyField
                    name={HAZMAT_FEE}
                    label={properCase(HAZMAT_FEE)}
                    disabled={locked}
                    required={markedHazardous}
                  />
                </Col>
              </FormRow>
              <FormRow>
                <Col md={6}>
                  <Field
                    name={PREFERRED_REPAIR_STATION_ID}
                    label="Suggested Repair Station"
                    placeholder="Type a vendor's name or code..."
                    component={AutoCompleteField}
                    search={searchRepairStations}
                    selectedItem={selectedPreferredRepairStation}
                    formatItem={result => result && result.name}
                    disabled={locked || purchaseForStock}
                    watch={
                      purchaseForStock
                        ? selectedPreferredRepairStation
                        : undefined
                    }
                    required={this.repairStationRequired}
                    onItemSelected={this.handlePreferredRepairStation}
                  />
                </Col>
                <Col md={6}>
                  <Field
                    name={EVALUATION_PERIOD}
                    type="number"
                    component={FormInput}
                    disabled={locked}
                    label="Eval. Period"
                  />
                </Col>
              </FormRow>
              <FormRow>
                <Col md={6}>
                  <Field
                    name={CAP_TYPE}
                    className="text-right"
                    component={Select}
                    options={toOptions(CAP_TYPES)}
                    label="Repair/Overhaul Cap"
                  />
                </Col>
                {capType && (
                  <Col md={6}>
                    <CurrencyField
                      name={CAP_AMOUNT}
                      label={`${CAP_TYPES[capType].label} Cap Amount`}
                      disabled={locked}
                    />
                  </Col>
                )}
              </FormRow>
              <FormRow>
                <Col md={12}>
                  <Fields
                    names={[AMOUNT_INSURED, PERCENT_INSURED, INSURANCE_TYPE]}
                    component={InsuranceTypeField}
                    disabled={locked}
                  />
                </Col>
              </FormRow>
              <FormRow>
                <Fields
                  names={[
                    AMOUNT_INSURED,
                    PERCENT_INSURED,
                    INSURANCE_TYPE,
                    COST,
                    QUANTITY
                  ]}
                  component={InsuranceFields}
                  disabled={locked}
                />
              </FormRow>
              <DashedSeparator />
              <h4>Notes</h4>
              {getFieldValue(DO_NOT_EXCHANGE) && (
                <Warning>
                  Must have a valid reason for Do Not Exchange to continue.
                </Warning>
              )}
              <FormRow>
                <Col md={6}>
                  <Field
                    name={INTERNAL_NOTE}
                    required={getFieldValue(DO_NOT_EXCHANGE)}
                    label={properCase(INTERNAL_NOTE)}
                    component={TextArea}
                    rows={5}
                    disabled={locked}
                  />
                </Col>
                <Col md={6}>
                  <Field
                    name={EXTERNAL_NOTE}
                    label={properCase(EXTERNAL_NOTE)}
                    component={TextArea}
                    rows={5}
                    disabled={locked}
                  />
                </Col>
              </FormRow>
              {cancelled && (
                <FormRow>
                  <Col md={6}>
                    <Field
                      name={CANCELLATION_REASON}
                      className="text-right"
                      component={Select}
                      options={CANCELLATION_REASONS}
                      prompt={false}
                      label={properCase(CANCELLATION_REASON)}
                    />
                  </Col>
                </FormRow>
              )}
            </Col>
            {modalMode && (
              <Col md={4}>
                <PartSummary
                  part={selectedPart}
                  cost={cost}
                  quantity={quantity}
                  lineItem={this.props.selectedLineItem}
                  hazmatFee={hazmatFee}
                  containerFee={containerFee}
                />
                {assignedCoreReturn &&
                  this.props.selectedLineItem.core_return_date && (
                    <div className="well">
                      <h6 className="h4">Core Return Details</h6>
                      <table className="table table-condensed table-padding-horizonal-none margin-bottom-none">
                        <tbody>
                          <tr>
                            <td>Core Return Date</td>
                            <td className="text-right">
                              {shortDate(
                                this.props.selectedLineItem.core_return_date
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td>Core Return Serial #</td>
                            <td className="text-right">
                              {assignedCoreReturn.serial_number}
                            </td>
                          </tr>
                          <tr>
                            <td>Core Return Condition</td>
                            <td className="text-right">
                              {CONDITIONS[assignedCoreReturn.condition].label}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  )}
              </Col>
            )}
          </div>
        </AppForm.Body>
        {renderFooter && renderFooter(formProps)}
      </AppForm>
    );
  }
}

const selector = formValueSelector(formName);

export default connect(
  state => ({
    getFieldValue: field => selector(state, field),
    getInitialFieldValue: field =>
      _.get(getFormInitialValues(formName)(state), field),
    buyerCreditPct: selector(state, BUYER_CREDIT_PCT),
    capType: selector(state, CAP_TYPE),
    cost: selector(state, COST),
    quantity: selector(state, QUANTITY),
    condition: selector(state, CONDITION),
    srpCondition: selector(state, SRP_CONDITION),
    srp: selector(state, SUGGESTED_RETAIL),
    minExchangeSrp: state.session.getIn([SETTINGS, MINIMUM_EXCHANGE_SRP]),
    exchangeSRP: selector(state, EXCHANGE_SRP),
    asIs: selector(state, AS_IS),
    currentUser: state.session.get(USER).toJS(),
    purchaseOrder: state.purchaseOrderDetail.get("purchaseOrder").toJS(),
    hazmatFee: selector(state, HAZMAT_FEE),
    containerFee: selector(state, CONTAINER_FEE),
    markedHazardous: selector(state, HAZMAT),
    modTo: selector(state, MOD_TO),
    purchaseForStock: selector(state, PURCHASE_FOR_STOCK),
    purchaseForRepair: selector(state, PURCHASE_FOR_REPAIR),
    dom: selector(state, DOM),
    getField: field => selector(state, field)
  }),
  dispatch => ({
    resetAlternatePartField: () =>
      dispatch(change(formName, ALTERNATE_ID, null)),
    resetExchangeSrpField: () => dispatch(change(formName, EXCHANGE_SRP, null)),
    changeExchangeSrpField: value =>
      dispatch(change(formName, EXCHANGE_SRP, value)),
    setPartId: id => dispatch(change(formName, PART_ID, id)),
    setHazardFields: part => {
      dispatch(change(formName, BIO_HAZMAT, part.bio_hazmat));
      dispatch(change(formName, HAZMAT, part.hazmat));
    },
    setHeavyPackage: part =>
      dispatch(change(formName, DIM_WEIGHT, part.dim_weight)),
    searchAlternates: partId => dispatch(actions.searchAlternates(partId)),
    searchBuyers: filter => dispatch(actions.searchBuyers(filter)),
    searchParts: filter => dispatch(partsActions.searchPoParts(filter)),
    searchRepairStations: filter =>
      dispatch(actions.searchRepairStations(filter)),
    resetForm: id => {
      dispatch(replace(`/purchase-orders/${id}`));
    },
    setExpectedDate: date => dispatch(change(formName, "expected_date", date)),
    setLeadTime: leadTime => dispatch(change(formName, LEAD_TIME, leadTime)),
    setFieldValue: field => val => dispatch(change(formName, field, val)),
    setTaggedById: id => dispatch(change(formName, TAGGED_BY_ID, id)),
    setTaggedByHold: hold => dispatch(change(formName, TAGGED_BY_HOLD, hold)),
    setPreferredRepairStationHold: hold =>
      dispatch(change(formName, "preferred_repair_station_hold", hold)),
    resetPreferredRepairStation: () =>
      dispatch(change(formName, "preferred_repair_station_id", ""))
  })
)(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/components/Detail/LineItemsTable/Form.jsx